var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}import React, { Component } from 'react';
import { Icon } from "../UI";
import { t } from "../I18N";
import ModalTips from "../App/ModalTips";
import { SearchTipsContent } from "../App/SearchTipsContent";

export class SearchInput extends Component {
  render() {
    return /*#__PURE__*/(
      _jsx("div", { className: "input-group" }, void 0, /*#__PURE__*/
      React.createElement("input", _extends({
        type: "text",
        className: "form-control",
        placeholder: t('System', 'Search', null, false) },
      this.props)
      ), /*#__PURE__*/
      _jsx(Icon, { icon: "search" }), /*#__PURE__*/
      _jsx(ModalTips, {
        label: t('System', 'Search Tips', null, false),
        title: t('System', 'Narrow down your searches', null, false) }, void 0, /*#__PURE__*/

      _jsx(SearchTipsContent, {})
      )
      ));

  }
}

export default SearchInput;